import React, { useState, ReactNode } from 'react';
import { Layout, Menu, theme, Input, Button, Dropdown, Space, Spin } from 'antd';
import { PlusOutlined, UserOutlined, PoweroffOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import './index.css'
import { Route, Routes, Navigate, useLocation, useNavigate } from 'react-router-dom'

import { routes } from "@/routes"
import logo from "@/assets/logo.png"
import nprogress from "nprogress";
import "@/components/progress/index.css";


const { Header, Content, Footer } = Layout;
const { Search } = Input;
const baseUrl = process.env.REACT_APP_API_BASE_URL
const Rootview: React.FC = () => {
	//路由加载进度条
	nprogress.start();
	setTimeout(() => {
		nprogress.done();
	}, 200);


	const titleH2 = process.env.REACT_APP_TITLE
	const navigate = useNavigate()
	const location = useLocation()
	const [current, setCurrent] = useState<string>(location.pathname);
	const {
		token: { colorBgContainer },
	} = theme.useToken();

	// 点击菜单
	const onClick: MenuProps['onClick'] = e => {
		navigate(e.key)
		setCurrent(e.key);
	};

	// 搜索
	const onSearch = () => { }

	// 发布
	const release = () => { }
	return (
		<>
			<Layout className="layout">
				<Header style={{ position: 'sticky', top: 0, zIndex: 1, width: '100%' }}>
					<div className="logo">
						<img src={logo} alt="" />
						<span className='logoTitle'>{titleH2}</span>
					</div>
					<Menu onClick={onClick} selectedKeys={[current]} mode="horizontal" items={routes} theme="light" />
					<div className="head-right">
						<Search className="searchms" placeholder="请搜索面试题" onSearch={onSearch} enterButton style={{ width: '60%' }} />

						<Button type="primary" icon={<PlusOutlined />} onClick={release} className="fabu">
							发布
						</Button>

						<UserInfo />
					</div>

				</Header>

				<Content>
					<div className="site-layout-content" style={{ background: colorBgContainer }}>
						<Routes>
							{getRoutes(routes)}
							{/* 重定向404 */}
							<Route path="*" element={<Navigate to="/404" />}></Route>
						</Routes>
					</div>
				</Content>

				<Footer style={{ textAlign: 'center' }}>GongChengSHI ©2023 by ZiChen_Jiang</Footer>
			</Layout>
		</>
	);

}

// 用户
function UserInfo() {
	interface userData { [key: string]: string | any }
	// 本地个人信息
	const userInfo: userData = JSON.parse(localStorage.getItem('userInfo') || '0')
	const items: any = [
		{
			key: '1',
			label: '个人中心',
			icon: <UserOutlined />,
		},
		{
			key: '2',
			label: '退出登录',
			icon: <PoweroffOutlined />,
		},
	]
	const navigate = useNavigate()
	const handleMenuClick = (e: any) => {
		switch (e.key) {
			case '1':
				break;
			case '2':
				localStorage.clear();
				sessionStorage.clear()
				setTimeout(() => {
					window.location.reload()
				}, 500)
				navigate('/login')
				break;
			default:
				break;
		}
	}
	return (
		<>
			{userInfo ?
				<div className="userName">
					<Dropdown menu={{ items, onClick: handleMenuClick, }}>
						<img src={baseUrl + userInfo.userImg} alt="" className='userImg' />
					</Dropdown>
				</div>
				: <Button className="userName" type="primary" onClick={() => { handleMenuClick({ key: '2' }) }} >
					登录
				</Button>
			}

		</>
	)
}
// 遍历路由组件
function getRoutes(routes: any) {
	const routesElement = routes.map((item: { key: string; element: ReactNode; children: any }, index: number) => {
		return (
			<React.Fragment key={index}>
				<Route path={item.key} element={item.element} key={index}></Route>
				{item.children ? getRoutes(item.children) : null}
			</React.Fragment>
		);
	});
	return routesElement;
}

export default Rootview;
